import { EvidenceStatus } from '@seapoint/server/enums';
import { InvoiceEvidenceView } from '../../../types/entity-types';

export const getInReviewInvoices = (evidences: InvoiceEvidenceView[]) => {
  return evidences.filter((e) => e.status === EvidenceStatus.IS_PAID_PROCESSED && e.isPaid === true);
};
